import { SubscriptionStatus } from '@/lib/api/subscriptions';

export const SUBSCRIPTION_STATUS_EVENT = 'subscriptionStatusUpdated';

export function broadcastSubscriptionStatus(status: SubscriptionStatus) {
  if (typeof window === 'undefined') {
    return;
  }

  const event = new CustomEvent<SubscriptionStatus>(SUBSCRIPTION_STATUS_EVENT, {
    detail: status,
  });

  window.dispatchEvent(event);
}
